#import '../../templates/template-groups/graphql/fragments/email-sequence-template-stub-basic.graphql'

fragment EmailSequenceTemplateTemplate on EmailSequenceTemplate {
    ...EmailSequenceTemplateStubBasic
    isImmutable
    isArchived
    parent {
        id
    }
    emailSequenceTemplateMessages {
        id
        sendAsReply
        useSignature
        position
        sendDelay {
            delayTimespan
        }
        emailTemplate {
            id
            subject
            plaintextBody
            body
            sentCount
            openedCount
            clickCount
        }
    }
}
